import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import partnerPropTypes from '../../partnerPropTypes.js';

import LargeError from '../../errors/largeError.jsx';
import RufsError from '../../errors/rufsError.jsx';

const PaymentError = ({ params, partner }) => {
    if (params && params.code === '1') {
        return (
            <LargeError
                heading={`${partner.name} er ikke lenger verifisert`}
                imageSrc="/static/images/400.jpg"
            >
                Dere kan ikke bruke Trygg betaling før {partner.name}{' '}
                <a href="https://hjelpesenter.finn.no/hc/no/articles/208426349">
                    bekrefter sin identitet på nytt
                </a>.
            </LargeError>
        );
    }

    return (
        <RufsError>
            <p>
                Vi kan ikke ta imot betalingen akkurat nå. Prøv igjen om litt.
            </p>
        </RufsError>
    );
};

PaymentError.propTypes = {
    partner: partnerPropTypes.isRequired,
    params: PropTypes.shape({
        code: PropTypes.string,
    }),
};

function mapStateToProps(state) {
    return {
        partner: state.partner,
    };
}

export default connect(mapStateToProps)(PaymentError);



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/paymentError.jsx